import { render } from "./amendment-text-display.vue?vue&type=template&id=14cb8966"
import script from "./amendment-text-display.vue?vue&type=script&lang=js"
export * from "./amendment-text-display.vue?vue&type=script&lang=js"

import "./amendment-text-display.vue?vue&type=style&index=0&id=14cb8966&lang=css"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__